import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../../components/Loader";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useSelector((state) => state.user);
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  // 1. Se não estiver autenticado, vai para o login
  if (!user?.id) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2. Se for Caixa, a única rota permitida é a de emissão de documento
  if (user?.nivel?.toLowerCase() === "caixa") {
    const rotaPermitidaUnica = "/faturacao/emitir-documento/";

    if (location.pathname !== rotaPermitidaUnica) {
      return <Navigate to="/faturacao/emitir-documento/" replace />;
    }
  }

  // 3. Se for outro nível (Admin, Gerente, etc.), tem livre acesso às rotas protegidas
  return children;
};

export default PrivateRoute;
